// packages/brand-config/brands/eweadn/index.ts
import type { BrandConfig } from "../../src/types";
import { createInitBrandTheme } from "../../src/initBrandThemeWithLocale";
import meta from "./brand.json";
import theme from "./theme.json";

export const brandConfig: BrandConfig = {
  meta: meta as BrandConfig["meta"],
  tokens: theme as BrandConfig["tokens"],
};

/** 应用当前构建所选品牌主题（默认 eweadn，与现网一致） */
export const initBrandTheme = createInitBrandTheme(brandConfig);

export { brandConfig as default };
